function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercise2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5B62"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M436.571,163.698c0,0-58.303-8.618-68.284-5.445c-9.982,3.173-25.412,5.445-33.121,4.31 c-7.713-1.136-54.899-11.112-65.559-6.351c-10.66,4.762-14.29,2.494-14.29,2.494s-12.023-7.034-15.427-5.445 c-3.404,1.589-2.61-15.2-2.61-15.2h-37.089v14.517c0,0-12.933,0.341-18.378,3.742c-5.445,3.404-11.002-3.63-19.283-1.021 c-8.282,2.61-30.285,5.898-30.285,5.898s-38.567-2.721-53.536,1.815c-14.974,4.535-17.921,22.456-3.178,29.038 c14.743,6.582,45.144,3.63,48.774,4.993c3.63,1.358,22.909,6.577,27.676,9.298c4.762,2.725,8.166,43.781,16.784,61.476 c8.623,17.694,1.362,44.008,1.362,44.008h98.227c0,0-0.684-27.676,0.679-39.02s12.249-41.287,15.879-50.359 c3.63-9.076,3.63-12.706,3.63-12.706s27.223-8.623,39.472-13.159c12.249-4.54,21.325-6.351,21.325-6.351s15.598,2.157,24.674,1.473 c9.076-0.679,62.612-11.57,62.612-11.57s6.808,10.207,11.117,9.982c4.31-0.227,1.589-12.701,6.124-10.434s-1.815,9.982-4.083,13.159 c-2.273,3.178,14.517-2.268,15.879-7.713c1.358-5.445,0-21.32-10.439-21.32c-10.434,0-18.651-0.116-18.651-0.116L436.571,163.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B57F"
    },
    d: "M237.197,141.515c0.009-2.004,0.079-3.455,0.079-3.455h-37.089v5.067 c3.649,3.533,7.866,7.307,10.563,9.043c2.91,0.638,5.081,1.011,7.122,1.123c2.041-0.111,4.213-0.49,7.117-1.123 C228.102,150.166,233.248,145.445,237.197,141.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M326.82,161.084c-16.244-2.965-48.608-8.716-57.212-4.872c-10.66,4.767-14.29,2.494-14.29,2.494 s-5.266-3.081-9.81-4.702c-7.922,14.078-27.362,12.558-27.362,12.558s-19.856,1.557-27.611-13.007 c-3.238,0.554-6.568,1.422-8.72,2.772c-5.445,3.404-11.002-3.63-19.283-1.021c-8.282,2.61-30.285,5.898-30.285,5.898 s-2.988-0.208-7.621-0.415v36.377c4.314,1.515,22.72,6.535,27.357,9.182c4.762,2.725,8.166,43.781,16.784,61.481 c8.618,17.694,1.362,44.008,1.362,44.008h98.227c0,0-0.679-27.676,0.684-39.02c1.362-11.344,12.249-41.287,15.879-50.359 c3.626-9.076,3.626-12.706,3.626-12.706s25.546-8.087,38.28-12.72v-35.948L326.82,161.084L326.82,161.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M146.434,204.035c2.411,0.854,4.397,1.654,5.547,2.309c4.762,2.725,8.166,43.781,16.784,61.481 c4.273,8.767,4.647,19.653,3.93,28.406c0.318-3.792,1.197-15.422,0.55-22.359c-0.78-8.383-5.459-20.466-8.383-31.773 c-2.923-11.307-5.848-34.308-8.577-37.232c-2.721-2.914-9.806-0.84-9.857-0.826L146.434,204.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M450.002,139.45c19.556,0,35.412,15.856,35.412,35.412s-15.856,35.408-35.412,35.408 s-35.408-15.852-35.408-35.408S430.446,139.45,450.002,139.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M450.7,140.84c19.173,0,34.715,15.543,34.715,34.714s-15.543,34.71-34.715,34.71 s-34.714-15.543-34.714-34.71C415.985,156.383,431.527,140.84,450.7,140.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADA"
    },
    d: "M450.7,148.475c14.956,0,27.08,12.124,27.08,27.08s-12.124,27.08-27.08,27.08 c-14.96,0-27.084-12.124-27.084-27.08S435.74,148.475,450.7,148.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C8C8"
    },
    d: "M450.7,168.298c4.009,0,7.261,3.252,7.261,7.261c0,4.009-3.252,7.261-7.261,7.261 c-4.009,0-7.261-3.252-7.261-7.261C443.439,171.55,446.686,168.298,450.7,168.298z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M449.984,168.252c3.677,0,6.66,2.984,6.66,6.66c0,3.681-2.984,6.66-6.66,6.66 c-3.677,0-6.656-2.979-6.656-6.66C443.328,171.237,446.307,168.252,449.984,168.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M43.439,168.151h68.607c0.984,0,1.792,0.803,1.792,1.788v5.635c0,0.984-0.803,1.788-1.792,1.788 H43.439c-0.984,0-1.788-0.803-1.788-1.788v-5.635C41.652,168.955,42.456,168.151,43.439,168.151z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1BA"
    },
    d: "M61.457,162.081h0.005c2.314,0,4.213,1.672,4.213,3.723v19.861c0,2.046-1.898,3.718-4.213,3.718 h-0.005c-2.318,0-4.213-1.677-4.213-3.718v-19.861C57.245,163.758,59.138,162.081,61.457,162.081z M91.244,161.712h0.005 c2.318,0,4.213,1.677,4.213,3.723v19.861c0,2.041-1.903,3.718-4.213,3.718h-0.005c-2.314,0-4.213-1.677-4.213-3.718v-19.861 C87.031,163.389,88.925,161.712,91.244,161.712z M81.424,162.081L81.424,162.081c2.318,0,4.213,1.677,4.213,3.723v19.861 c0,2.041-1.898,3.718-4.213,3.718l0,0c-2.318,0-4.217-1.677-4.217-3.718v-19.861C77.207,163.758,79.102,162.081,81.424,162.081z  M71.286,162.081h0.005c2.314,0,4.217,1.677,4.217,3.723v19.861c0,2.046-1.898,3.718-4.217,3.718h-0.005 c-2.314,0-4.213-1.677-4.213-3.718v-19.861C67.074,163.758,68.967,162.081,71.286,162.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M53.721,141.311h-7.727c-1.252,0-2.273,1.021-2.273,2.273v58.354c0,1.252,1.021,2.273,2.273,2.273 h7.727c1.252,0,2.273-1.021,2.273-2.273v-58.354C55.994,142.332,54.973,141.311,53.721,141.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M44.617,141.778c-0.545,0.416-0.896,1.072-0.896,1.805v58.354c0,0.735,0.355,1.39,0.896,1.805 c0.545-0.416,0.896-1.072,0.896-1.805v-58.354C45.513,142.849,45.163,142.193,44.617,141.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADA"
    },
    d: "M43.717,201.198v0.735c0,1.252,1.025,2.278,2.278,2.278h7.727c1.252,0,2.273-1.025,2.273-2.278 v-0.735H43.722H43.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1BA"
    },
    d: "M75.776,190.063h14.526c2.236,0,4.06,1.824,4.06,4.06l0,0c0,2.231-1.824,4.06-4.06,4.06H75.776 c-2.231,0-4.06-1.824-4.06-4.06l0,0C71.716,191.891,73.54,190.063,75.776,190.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M75.641,191.642h2.296v4.956h-2.296c-1.362,0-2.475-1.118-2.475-2.48l0,0 C73.166,192.751,74.279,191.642,75.641,191.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M109.862,141.311h-7.727c-1.252,0-2.273,1.021-2.273,2.273v58.354c0,1.252,1.021,2.273,2.273,2.273 h7.727c1.252,0,2.273-1.021,2.273-2.273v-58.354C112.135,142.332,111.109,141.311,109.862,141.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M100.758,141.778c-0.545,0.416-0.896,1.072-0.896,1.805v58.354c0,0.735,0.355,1.39,0.896,1.805 c0.54-0.416,0.896-1.072,0.896-1.805v-58.354C101.654,142.849,101.299,142.193,100.758,141.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADA"
    },
    d: "M99.862,201.198v0.735c0,1.252,1.025,2.278,2.278,2.278h7.727c1.252,0,2.273-1.025,2.273-2.278 v-0.735H99.867H99.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M188.557,96.255c0,0-1.45-3.187-5.349-1.607c-3.893,1.58,0.176,17.334,1.668,19.533 c1.487,2.199,3.884,0.803,4.758,0.716c1.238,9.395,1.348,15.865,5.113,19.823c3.561,3.751,11.713,11.395,16.009,14.06 c2.91,0.61,5.081,0.974,7.122,1.086c2.041-0.106,4.213-0.471,7.117-1.086c4.296-2.665,12.448-10.309,16.009-14.06 c3.76-3.958,3.87-10.434,5.113-19.823c0.873,0.088,3.266,1.483,4.758-0.716s5.561-17.953,1.663-19.533 c-3.893-1.58-5.344,1.607-5.344,1.607s3.852-12.369-2.997-24.549c-4.693-8.351-15.39-12.678-26.318-12.998 c-10.928,0.318-21.63,4.647-26.323,12.998c-6.845,12.179-2.993,24.549-2.993,24.549H188.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M243.821,99.941l2.716-0.093l0.873-3.099l2.559-2.554c1.691-12.72,2.19-32.516-10.439-31.944 c0,0-1.141-14.438-23.911-11.607c-22.776,2.831-33.065,17.533-31.837,29.801c1.229,12.263,0.73,13.75,0.73,13.75l2.559,2.554 l0.383,3.524l2.236-0.139c0,0,0.702-4.721,1.399-6.794c0.702-2.074,1.067-18.262,1.067-18.262 c2.254-2.886,17.777,1.589,23.755,1.455c5.63-0.125,22.946-5.057,23.56-3.519c2.896,4.434,4.347,26.922,4.347,26.922L243.821,99.941 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M170.719,311.832c-9.14,31.944-11.94,30.193-14.346,86.99l59.333,1.413l1.732-8.282h4.397 l1.728,8.282l59.333-1.413c-2.406-56.797-5.21-55.046-14.346-86.99h-48.912h-48.912H170.719z M219.35,382.762l0.277-1.334 l0.277,1.334h-0.559H219.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M156.374,398.822c0,0-2.291,47.536,0.194,59.573c2.489,12.036,2.712,12.258,2.712,12.258 s-1.132,13.371,1.58,20.503c0.36,0.942,0.661,1.935,0.919,2.942c10.873,4.305,22.115,7.875,33.657,10.674 c2.647-5.764,6.166-14.378,6.374-19.768c0.97-24.766,15.044-45.005,13.893-84.768l-59.333-1.413L156.374,398.822L156.374,398.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B57F"
    },
    d: "M195.434,504.772c2.642-5.764,6.161-14.378,6.374-19.768c0.97-24.766,15.044-45.005,13.893-84.768 c0,0-13.986,69.434-17.584,75.129c-3.598,5.695-2.499,15.182-5.792,18.979c-2.351,2.712-2.36,6.115-1.774,9.201 c1.621,0.429,3.252,0.836,4.886,1.229L195.434,504.772L195.434,504.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M282.89,398.822c0,0,2.296,47.541-0.194,59.573c-2.489,12.036-2.712,12.258-2.712,12.258 s1.132,13.371-1.584,20.503c-2.125,5.579-2.309,15.852-2.291,20.06c-6.637,0.517-13.344,0.78-20.11,0.78 c-3.63,0-7.233-0.093-10.827-0.245c-2.582-6.771-7.473-20.369-7.723-26.752c-0.965-24.766-15.044-45.005-13.893-84.768l59.333-1.413 L282.89,398.822L282.89,398.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B57F"
    },
    d: "M244.878,511.742c-2.637-6.563-7.187-20.591-7.426-26.738c-0.965-24.766-15.044-45.005-13.893-84.768 c0,0,13.986,69.434,17.584,75.129c3.598,5.695,2.499,15.186,5.792,18.983c3.224,3.714,1.626,14.928,0.942,17.515 c-1.002-0.032-2-0.074-2.997-0.116L244.878,511.742L244.878,511.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M326.82,197.032c0,0-34.183,9.099-37.204,8.609c-3.021-0.49-5.848-4.485-5.848-4.485 s-0.485,13.256-2.438,19.884c-1.949,6.628-16.276,40.544-15.302,55.943c0.974,15.399,2.318,34.849,2.318,34.849 s-0.679-27.676,0.684-39.02s12.249-41.287,15.879-50.359c3.626-9.076,3.626-12.706,3.626-12.706s25.546-8.087,38.28-12.72 L326.82,197.032z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise2);
export default __webpack_public_path__ + "static/media/exercise2.b9e3dfa8c0d8ad2f98c923f65846a7b0.svg";
export { ForwardRef as ReactComponent };